import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
  SVGIcon,
  Button,
  Tab as TabComponent,
  TabList as TabListComponent,
  TabPanels as TabPanelsComponent,
} from '@pearsontechnology/aero-components';

const HelpButtonElement = styled(Button)`
  position: fixed;
  bottom: 14px;
  right: 14px;
  z-index: 50;
  text-transform: capitalize;
  padding: 0 8px 0 15px;
  background: ${(props) => props.theme['color.blueGreyLighter']};
  transition: box-shadow 0.3s ease, background 0.3s ease;
`;

/* Positioned immediately to the left of the Help button.
   Help button is ~80 px wide at right:14px, so right:102px leaves an 8px gap. */
const AIButtonElement = styled(Button)`
  position: fixed;
  bottom: 14px;
  right: 102px;
  z-index: 50;
  text-transform: capitalize;
  padding: 0 8px 0 12px;
  background: ${(props) => props.theme['color.blueGreyLighter']};
  transition: box-shadow 0.3s ease, background 0.3s ease;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 10px;
  top: 12px;
`;

export const HelpButton = forwardRef((props, ref) => (
  <HelpButtonElement primary rounded ref={ref} height={32} {...props}>
    Help
    <SVGIcon icon="help" size={{ width: '20', height: '20' }} />
  </HelpButtonElement>
));

export const AIButton = forwardRef((props, ref) => (
  <AIButtonElement primary rounded ref={ref} height={32} {...props}>
    AI
    <svg
      width="16"
      height="16"
      viewBox="0 0 22 22"
      fill="none"
      aria-hidden="true"
      style={{ marginLeft: '6px' }}
    >
      <path
        d="M11 2v3M11 17v3M2 11h3M17 11h3M4.22 4.22l2.12 2.12M15.66 15.66l2.12 2.12M4.22 17.78l2.12-2.12M15.66 6.34l2.12-2.12"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="11" cy="11" r="3" fill="currentColor" />
    </svg>
  </AIButtonElement>
));

export const PanelContainer = styled.div`
  position: relative;
  justify-items: ${(props) => props.alignRight ? 'flex-end' : 'flex-start'};
  pointer-events: none;
  display: flex;
  flex-direction: column-reverse;

  > * {
    pointer-events: auto;
  }
`;

export const Tab = styled(TabComponent)`
  margin: 15px 9px 0 0;
`;

export const TabList = styled(TabListComponent)`
  padding: 0px 20px;
  height: 60px;
`;

export const TabPanels = styled(TabPanelsComponent)`
  height: calc(100vh - 60px);
  overflow-y: scroll;
  scrollbar-width: none; /** HIDES SCROLLBAR FROM FIREFOX */

  /** HIDES SCROLLBAR FROM EDGE/CHROME/SAFARI */
  ::-webkit-scrollbar {
      width: 0px;
      background: red; /* make scrollbar transparent */
  }
`;

export const HorizontalSeparator = styled.div`
  width: 100%;
  height: 1px;
  margin-top: -1px;
  box-shadow: 0 1px 1px 0 ${(props) => props.theme.themeId === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.12)'};
  z-index: 1;
`;
